import TaxonomyHeader from '@/components/TaxonomyHeader'
import TaxonomyHeading from '@/components/TaxonomyHeading'
import { CARE_OPTIONS_DATA } from '@/domain/levelsOfCare/constants'
import React from 'react'
import { getLevelsOfCareSections } from '@/domain/levelsOfCare/useCases/getLevelsOfCareSections'

const heartPalm =
  'https://res.cloudinary.com/rehabpath/image/upload/v1683149980/hand-heart.svg'
const xMark =
  'https://res.cloudinary.com/rehabpath/image/upload/v1683581567/x-heavy_custom-gray.svg'
const checkMark =
  'https://res.cloudinary.com/rehabpath/image/upload/v1683581567/green-check.svg'

interface CareOptionsProps {
  centerPrimaryFocus?: string
  location: string
  treatmentServices: string[]
  whatWeTreat?: string[]
}

export interface CareOption {
  label: string
  description: string
  isTreatmentServiceProvided: boolean
  linkText?: string
  url?: string
}

interface CareOptionItemProps {
  item: CareOption
}

export const CareOptions: React.FC<CareOptionsProps> = ({
  centerPrimaryFocus = '',
  location,
  treatmentServices,
  whatWeTreat = []
}: CareOptionsProps) => {
  const careOptions = CARE_OPTIONS_DATA[centerPrimaryFocus] || {}

  const levelsOfCareSections = getLevelsOfCareSections(
    careOptions,
    centerPrimaryFocus,
    location,
    treatmentServices,
    whatWeTreat
  )

  return (
    <>
      <TaxonomyHeader>
        <img src={heartPalm} />
        <TaxonomyHeading tag="h3">Care Options</TaxonomyHeading>
      </TaxonomyHeader>
      <div className="my-8 max-w-prose text-base">
        {careOptions.description}
      </div>

      <div className="flex flex-col gap-8">
        {levelsOfCareSections?.map((item) => (
          <CareOptionItem
            key={item.label}
            item={item}
          ></CareOptionItem>
        ))}
      </div>
    </>
  )
}

const CareOptionItem: React.FC<CareOptionItemProps> = ({
  item
}: CareOptionItemProps) => {
  return (
    <div className="flex items-start">
      <div className="shrink-0">
        <img
          src={item.isTreatmentServiceProvided ? checkMark : xMark}
          className="inline-block pr-4 pt-1"
        />
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex flex-wrap items-center gap-2 text-xl font-semibold text-gray-1100">
          <div>{item.label}</div>
          {!item.isTreatmentServiceProvided && (
            <div className="rounded-md bg-gray-200 px-2 text-sm font-semibold">
              Not Offered at This Center
            </div>
          )}
        </div>
        <div
          className="max-w-prose text-gray-800"
          dangerouslySetInnerHTML={{
            __html: item.description
          }}
        />

        {item?.linkText && (
          <a
            className="font-semibold text-gray-1100 underline"
            href={item.url}
          >
            {item.linkText}
          </a>
        )}
      </div>
    </div>
  )
}
